const adminUsersActionPrefix = '@admin-users/';

/* List of Redux constants */
export const ADMIN_USERS_SET_LIST = `${adminUsersActionPrefix}set-list`;
export const ADMIN_USERS_RESET_LIST = `${adminUsersActionPrefix}reset-list`;
export const ADMIN_USERS_SET_LIST_LOADING = `${adminUsersActionPrefix}set-list-loading`;
export const ADMIN_USERS_SET_ADDING_NEW_ADMIN = `${adminUsersActionPrefix}set-adding-new-admin`;
export const ADMIN_USERS_SET_NEW_ADMIN_ERRORS = `${adminUsersActionPrefix}set-new-admin-errors`;
export const ADMIN_USERS_SET_EDITING_ADMIN_PROFILE = `${adminUsersActionPrefix}set-editing-admin-profile`;
export const ADMIN_USERS_SET_QUERY_PARAMS = `${adminUsersActionPrefix}set-query-params`;
export const ADMIN_USERS_SET_USER_STATUS_UPDATING = `${adminUsersActionPrefix}set-user-status-updating`;

/* List of Sagas constants */
export const ADMIN_USERS_GET_LIST = `${adminUsersActionPrefix}get-list`;
export const ADMIN_USERS_ADD_NEW_ADMIN = `${adminUsersActionPrefix}add-new-admin`;
export const ADMIN_USERS_EDIT_ADMIN_PROFILE = `${adminUsersActionPrefix}edit-admin-profile`;
export const ADMIN_USERS_ENABLE_USER = `${adminUsersActionPrefix}enable-user`;
export const ADMIN_USERS_DISABLE_USER = `${adminUsersActionPrefix}disable-user`;


// WEBPACK FOOTER //
// ./src/actions/admin/users/types.js